var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"whoami"},[_c('span',{staticClass:"yellow-colored"},[(_vm.args.groot)?[_vm._v("Groot")]:[_vm._v("guest")]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }